export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9287.9435918a.jpg";